import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'

import { jobStatus } from '../utils'

import { Loading } from '../misc'
import Header from '../header'
import JobsList from '../../containers/jobs_list'

const JOBS_TO_RETRIEVE = 10

function sortByDateAsc(a, b) {
    if (a.job_date - b.job_date < 0) {
        return -1
    }

    if (a.job_date - b.job_date > 0) {
        return 1
    }

    return 0
}

function sortByPayDateDesc(a, b) {
    if (a.pay_date - b.pay_date < 0) {
        return 1
    }

    if (a.pay_date - b.pay_date > 0) {
        return -1
    }

    return 0
}

class Jobs extends Component {
    static propTypes = {
        account: PropTypes.object.isRequired,
        docs: PropTypes.object.isRequired,
        docsActions: PropTypes.shape({
            loadDoc: PropTypes.func.isRequired,
        }).isRequired,
        jobs: PropTypes.object.isRequired,
        jobsActions: PropTypes.object.isRequired,
    }

    componentDidMount() {
        this.props.docsActions.loadDoc('job-alert')

        if (! this.props.jobs.history) {
            this.props.jobsActions.loadJobs(this.props.account.user.crew.uuid)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            (this.props.jobs.history !== nextProps.jobs.history) &&
            (nextProps.jobs.history === null)
        ) {
            console.log('Reloading jobs')
            this.props.jobsActions.loadJobs(this.props.account.user.crew.uuid)
        }
    }

    _getCurrentJobs() {
        return this.props.jobs.history.filter(
            (item) => item.job_status !== jobStatus.PAID
        ).sort(sortByDateAsc)
    }

    _getRecentJobs() {
        // only get paid jobs and get the top jobs
        return this.props.jobs.history.filter(
            (item) => item.job_status === jobStatus.PAID
        ).sort(sortByPayDateDesc).slice(0, JOBS_TO_RETRIEVE)
    }

    render() {
        if (! this.props.jobs.history) {
            return (
                <div>
                    <Header title="Current Job & Billing" />

                    <div className="content">
                        <div className="content__inner">
                            <Loading />
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <div>
                <Header title="Current Job & Billing" />

                <div className="content">
                    <div className="content__inner content__inner--fluid">
                        { this.props.account.user.crew.onboarding_complete || (
                            <div className="alert alert--error text-strong">
                                Please fully complete your profile to be considered for the maximum
                                number of job opportunities.
                            </div>
                        ) }

                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">Open & Current Jobs</div>
                            </div>
                            <div className="box__content box__content--padded">
                                { this.props.docs['job-alert'] && (
                                    <div
                                        className="alert alert--success"
                                        dangerouslySetInnerHTML={{ __html: this.props.docs['job-alert'].body }}
                                    />
                                ) }

                                <JobsList jobs={ this._getCurrentJobs() } />
                            </div>
                        </div>
                    </div>

                    <div className="content__inner content__inner--fluid">
                        <div className="box">
                            <div className="box__header">
                                <div className="box__title">Recently Paid</div>
                            </div>
                            <div className="box__content box__content--padded">
                                <JobsList jobs={ this._getRecentJobs() } />
                            </div>
                        </div>
                    </div>

                    <div className="content__inner content__inner--fluid">
                        <Link className="btn btn--primary" to="jobs/history">
                            View Job History
                        </Link>
                    </div>
                </div>
            </div>
        )
    }
}

export default Jobs



// WEBPACK FOOTER //
// ./app/components/jobs/jobs.js